module.exports = fox._r("images/promo/contest/1192x400_gr.png", __webpack_public_path__ + "_/common/images/promo/contest/1192x400_gr.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/contest/1192x400_gr.png
// module id = 425
// module chunks = 2